/**
 * PanelElement — F12.H T12.H.3.
 *
 * Panel — lekki wrapper (bez cienia, bez ramki, tylko tło). Używany
 * gdy chcesz wizualnie wyróżnić grupę pól bez ciężaru karty.
 * Różni się od CardElement brakiem shadow + cieniejszym tłem.
 *
 * Settings: { title?, padding?: 'sm'|'md'|'lg', tone?: 'neutral'|'muted'|'accent' }
 */

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';

const PADDING_CLASS: Record<string, string> = {
  sm: 'p-2',
  md: 'p-4',
  lg: 'p-6',
};

const TONE_CLASS: Record<string, string> = {
  neutral: 'bg-bg-secondary',
  muted: 'bg-bg-tertiary',
  accent: 'bg-accent-50',
};

export const PanelElement: LayoutElementDefinition = {
  type: 'panel',
  category: 'kontenery',
  isContainer: true,
  label: 'Panel',
  icon: 'Square',
  defaultSettings: () => ({
    title: '',
    padding: 'md',
    tone: 'neutral',
  }),
  render: ({ element, children, mode }) => {
    const settings = (element.settings ?? {}) as {
      title?: string;
      padding?: 'sm' | 'md' | 'lg';
      tone?: 'neutral' | 'muted' | 'accent';
    };
    const paddingCls = PADDING_CLASS[settings.padding ?? 'md'] ?? 'p-4';
    const toneCls = TONE_CLASS[settings.tone ?? 'neutral'] ?? 'bg-bg-secondary';
    const isBuilder = mode === 'builder';

    return (
      <div
        className={`rounded-lg ${toneCls} ${paddingCls} ${isBuilder ? 'ring-2 ring-transparent hover:ring-accent-200 transition' : ''}`}
        data-testid={`panel-element-${element.id}`}
        data-element-type="panel"
      >
        {settings.title && (
          <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-text-secondary">
            {settings.title}
          </h3>
        )}
        {children.length > 0 ? (
          <div className="space-y-2">{children}</div>
        ) : isBuilder ? (
          <p className="text-xs italic text-text-muted">(panel pusty — przeciągnij elementy)</p>
        ) : null}
      </div>
    );
  },
};
